import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const YarnInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Yarn"
    sectionDisplayName="Yarn Section"
    backRoute="/sections/yarn"
  />
);

export default YarnInwardConsignment;
